import SvgIcon from "@mui/material/SvgIcon";

export const VerificationRequestsIcon = (props) => (
  <SvgIcon {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="24"
      fill="none"
      viewBox="0 0 24 24">
      <path
        stroke="#fff"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
        d="M10.442 22.254h-8.12v-.978a8.139 8.139 0 018.488-8.044 8.138 8.138 0 015.684 2.706m-6.052-6.315a4.511 4.511 0 100-9.022 4.511 4.511 0 000 9.022z"></path>
      <path
        stroke="#fff"
        strokeWidth="2"
        d="M15.17 22.878l-2.871-2.871.67-.67 2.201 2.2 5.99-5.99.67.67-6.66 6.66z"></path>
    </svg>
  </SvgIcon>
);
